export const JSON_FAQ_CONTENT = 'assets/data/faq.json';
export const JSON_HOWTO_CONTENT = 'assets/data/how-to.json';
export const MD_PRIVACY_CONTENT = 'assets/data/privacy.md';
export const MD_TERM_CONDITION_CONTENT = 'assets/data/term.md';
export const MD_MEMBERSHIP_INFO_CONTENT = 'assets/data/membership.md';
export const MD_SILVER_MEMBER = 'assets/data/silver-member.md';
export const MD_GOLD_MEMBER = 'assets/data/gold-member.md';
export const MD_PLATINUM_MEMBER = 'assets/data/platinum-member.md';
